import React from 'react';
import { ROUTES } from '@solarwindscloud/sso-nighthawk-shared';
import styles from './LinkToCommonLogin.module.scss';
import { redirectTo } from '../../utils/utils';

const LinkToCommonLogin = ({ children }) => (
  <span data-test-id="link-to-common-login" onClick={() => redirectTo(ROUTES.LOGIN)} className={styles.link}>
    {children}
  </span>
);

export default LinkToCommonLogin;
